// Capa que cubre el formulario v2 mientras se envía la inscripción: bloquea los botones (evita el
// doble envío) y avisa que puede tardar por los adjuntos. Usa la misma tarjeta de CargandoInscripcion.
import React from "react";
import simbolo from "../../../global/imagenes/logo_u_cuc.png";
import { useEstilosInscripcion } from "./estilosInscripcion";

export default function EnviandoInscripcion() {
  const classes = useEstilosInscripcion();
  return (
    <div className={classes.enviandoCapa}>
      <div className={`${classes.cargandoTarjeta} ${classes.enviandoTarjeta}`} role="status" aria-live="polite">
        <div className={classes.cargandoIndicador}>
          <div className={classes.cargandoAnillo} />
          <img src={simbolo} alt="" className={classes.cargandoSimbolo} />
        </div>
        <p className={classes.cargandoTitulo}>Estamos enviando tu inscripción</p>
        <p className={classes.cargandoTexto}>No cierres ni recargues esta página. Esto puede tardar un poco.</p>
        <div className={classes.cargandoBarra}>
          <span />
        </div>
      </div>
    </div>
  );
}
